import React, { FC } from 'react';
import { UnifiedKeypoints } from '@exerai/vision-engine-web';
import { SideGaitResultsInsights } from '@/common/types';
import { useResultsInsights } from './hooks/ResultsInsights';
import { ResultsInsightsFrameLink, ResultsInsightsRow } from './styles';

interface SideGaitResultsInsightsProps {
    resultsInsights: SideGaitResultsInsights;
    poseLog: UnifiedKeypoints[];
    handleGoToClick: (n: number) => void;
}

export const SideGaitResultsInsightsDisplay: FC<SideGaitResultsInsightsProps> = ({
    resultsInsights,
    poseLog,
    handleGoToClick,
}) => {
    const {
        leftCycleStartFrame,
        leftCycleEndFrame,
        rightCycleStartFrame,
        rightCycleEndFrame,
        leftStepStartFrame,
        rightStepStartFrame,
    } = useResultsInsights(resultsInsights, poseLog);

    return (
        <>
            {resultsInsights && (
                <>
                    <ResultsInsightsRow>
                        <strong>Left Cycle Start Frame: </strong>{' '}
                        {leftCycleStartFrame ? (
                            <ResultsInsightsFrameLink
                                onClick={() => {
                                    handleGoToClick(leftCycleStartFrame);
                                }}
                            >
                                {leftCycleStartFrame.toString()}
                            </ResultsInsightsFrameLink>
                        ) : (
                            '-'
                        )}
                    </ResultsInsightsRow>
                    <ResultsInsightsRow>
                        <strong>Left Step Start Frame: </strong>{' '}
                        {leftStepStartFrame ? (
                            <ResultsInsightsFrameLink
                                onClick={() => {
                                    handleGoToClick(leftStepStartFrame);
                                }}
                            >
                                {leftStepStartFrame.toString()}
                            </ResultsInsightsFrameLink>
                        ) : (
                            '-'
                        )}
                    </ResultsInsightsRow>
                    <ResultsInsightsRow>
                        <strong>Left Cycle End Frame: </strong>{' '}
                        {leftCycleEndFrame ? (
                            <ResultsInsightsFrameLink
                                onClick={() => {
                                    handleGoToClick(leftCycleEndFrame);
                                }}
                            >
                                {leftCycleEndFrame.toString()}
                            </ResultsInsightsFrameLink>
                        ) : (
                            '-'
                        )}
                    </ResultsInsightsRow>
                    <div>---</div>
                    <ResultsInsightsRow>
                        <strong>Right Cycle Start Frame: </strong>{' '}
                        {rightCycleStartFrame ? (
                            <ResultsInsightsFrameLink
                                onClick={() => {
                                    handleGoToClick(rightCycleStartFrame);
                                }}
                            >
                                {rightCycleStartFrame.toString()}
                            </ResultsInsightsFrameLink>
                        ) : (
                            '-'
                        )}
                    </ResultsInsightsRow>
                    <ResultsInsightsRow>
                        <strong>Right Step Start Frame: </strong>{' '}
                        {rightStepStartFrame ? (
                            <ResultsInsightsFrameLink
                                onClick={() => {
                                    handleGoToClick(rightStepStartFrame);
                                }}
                            >
                                {rightStepStartFrame.toString()}
                            </ResultsInsightsFrameLink>
                        ) : (
                            '-'
                        )}
                    </ResultsInsightsRow>
                    <ResultsInsightsRow>
                        <strong>Right Cycle End Frame: </strong>{' '}
                        {rightCycleEndFrame ? (
                            <ResultsInsightsFrameLink
                                onClick={() => {
                                    handleGoToClick(rightCycleEndFrame);
                                }}
                            >
                                {rightCycleEndFrame.toString()}
                            </ResultsInsightsFrameLink>
                        ) : (
                            '-'
                        )}
                    </ResultsInsightsRow>
                </>
            )}
        </>
    );
};
